import { Component, computed, input } from '@angular/core';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { SectionTemplateComponent } from '@templates/section-template/section-template.component';
import { TPageData } from '@shared/constants/models.const';
import { TagSectionComponent } from '@shared/components/tag-section/tag-section.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

export enum E_TITLE_SIZES {
  md = 'md',
  lg = 'lg',
}

@Component({
  selector: 'app-three-column-template',
  imports: [
    SafeHtmlPipe,
    SectionTemplateComponent,
    TagSectionComponent,
    MatProgressSpinner,
  ],
  templateUrl: './three-column-template.component.html',
  styleUrl: './three-column-template.component.scss',
})
export class ThreeColumnTemplateComponent {
  pageTitle = input<string>('');

  titleSize = input<E_TITLE_SIZES>(E_TITLE_SIZES.lg);
  titleCssClass = computed(() => `item-title-${this.titleSize()}`);

  hasBreadcrumb = input<boolean>(true);
  showBreadcrumbAlways = input<boolean>(false);

  hasCustomTitle = input<boolean>(false);
  hasCustomMain = input<boolean>(false);
  customDateField = input<string>('');
  showTags = input<boolean>(true);
  showLoader = input<boolean>(false);
  pageData = input<TPageData | any>();
  hasMinWidth = input<boolean>(false);
  show2columns = input<boolean>(false);
}
